import { hitsApi } from '../../../api';
import type { GameStateSetter } from '../types';

export const createFetchHits = (set: GameStateSetter) => {
  return async (boardId: string): Promise<void> => {
    set({ isLoadingHits: true, hitsError: null, boardId });
    try {
      const hits = await hitsApi.getAll(boardId);
      set({ hits, isLoadingHits: false });
    } catch (err) {
      set({
        hitsError: err instanceof Error ? err.message : 'Failed to fetch scores',
        isLoadingHits: false,
      });
    }
  };
};
